import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    profileSlug: String
  };
  static targets = [ "newDropzone", "editDropzone", "assetsList", "dropzoneActions" ]

  initialize() {
    window.imageIds = [];
    window.videoIds = [];
    window.folderIds = [];
    if(this.hasNewDropzoneTarget) {
      window.Assets.newUiInitializeDropzone(this.profileSlugValue, this.newDropzoneTarget.id);
    }
    if(this.hasEditDropzoneTarget) {
      window.Assets.newUiInitializeEditDropzone(this.profileSlugValue);
    }
  }

  dragStart(e) {
    e.stopPropagation();
    e.preventDefault();
    if (e.dataTransfer.types && e.dataTransfer.types.includes('Files')){
      this.newDropzoneTarget.style.visibility = 'visible'
      this.dropzoneActionsTarget.style.visibility = 'visible'
      this.dropzoneActionsTarget.style.opacity = 1
      this.newDropzoneTarget.style.pointerEvents = 'auto'

    }
  }

  dragEnd(e) {
    e.stopPropagation();
    e.preventDefault();
    if (this.hasAssetsListTarget && !document.querySelector('.dz-details')) {
      this.newDropzoneTarget.style.visibility = 'hidden'
      this.dropzoneActionsTarget.style.visibility = 'visible'
      this.dropzoneActionsTarget.style.opacity = 0.7
      this.newDropzoneTarget.style.pointerEvents = 'none'
    }
  }
}